// Form inputs
import { MpfFormFieldConfig } from '../../lib/components/MpfForm/MpfForm.props';

export const inputReporterType: MpfFormFieldConfig = {
  modelValue: null,
  name: 'reporterType',
  type: 'radios',
  label: 'Who is the request for?',
  legendHeadingSize: 'l',
  legendHeadingLevel: 1,
  items: [
    { label: 'Me', value: 'PATIENT', type: 'radio' },
    { label: 'Someone else', value: 'PROXY', type: 'radio' },
  ],
  required: true,
};

export const inputFirstName: MpfFormFieldConfig = {
  name: 'firstName',
  label: 'First name',
  hint: 'As it would appear on medical records',
  type: 'text',
  required: true,
};
export const inputLastName: MpfFormFieldConfig = {
  name: 'lastName',
  label: 'Last name',
  type: 'text',
  required: true,
};
export const inputRelationshipToPatient: MpfFormFieldConfig = {
  name: 'relationshipToPatient',
  label: 'Relationship to patient',
  type: 'text',
  required: true,
};

export const inputPostcode: MpfFormFieldConfig = {
  name: 'postcode',
  label: 'Postcode',
  type: 'postcode',
  required: true,
};

export const inputDateOfBirth: MpfFormFieldConfig = {
  name: 'dateOfBirth',
  label: 'Date of birth',
  hint: 'For example, 15 3 1984',
  type: 'dateOfBirth',
  required: true,
  legendFontWeight: 'normal',
  legendHeadingSize: 's',
};

// TODO: make text areas
export const inputProblemDescription: MpfFormFieldConfig = {
  name: 'problemDescription',
  label: 'Tell us about your health concern in your own words',
  hint: "For example, when it started, any changes, worries, how it affects your day, or the help you're hoping for",
  type: 'textarea',
  required: true,
  headingLevelSize: 's',
  rows: 5,
};

export const inputAttachments: MpfFormFieldConfig = {
  modelValue: [],
  name: 'attachments',
  label: 'Attachments',
  hint: 'Attachments will be added to your clinical record and may be seen by male or female staff.',
  type: 'attachments',
  required: false,
  headingLevelSize: 's',
  headingLevel: 2,
  maxFileSize: 5 * 1024 * 1024,
  multiple: true,
};

export const inputProblemRecentContact: MpfFormFieldConfig = {
  name: 'problemRecentContact',
  label:
    'Include details of any recent contact with a healthcare professional about your concern (optional)',
  hint: 'For example, who you spoke to and any advice or treatment',
  type: 'textarea',
  required: false,
  headingLevelSize: 's',
  rows: 5,
};

export const inputAdminRequest: MpfFormFieldConfig = {
  name: 'adminRequest',
  label: 'Please describe your request',
  type: 'textarea',
  required: true,
  headingLevelSize: 's',
  rows: 5,
};

export const inputVerificationCode: MpfFormFieldConfig = {
  name: 'verificationCode',
  label: 'Verification code',
  hint: 'It should be 6 digits',
  type: 'text',
  required: true,
  errors: ['Verification code is required'],
};

export const inputAvailablePrescriptions: MpfFormFieldConfig = {
  modelValue: null,
  name: 'availablePrescriptions',
  type: 'checkboxes',
  label: 'Repeat medications',
  hint: 'You can choose more than one option.',
  items: [],
  required: false,
};

export const inputAvailableAcutePrescriptions: MpfFormFieldConfig = {
  modelValue: null,
  name: 'availablePrescriptionsAcute',
  type: 'checkboxes',
  label: 'Past acute medications (6 months)',
  hint: 'You can choose more than one option.',
  items: [],
  required: false,
};

// Single checkbox that reveals the free-text note field on the prescription list.
export const inputAddNoteToggle: MpfFormFieldConfig = {
  modelValue: null,
  name: 'addNoteToggle',
  type: 'checkboxes',
  label: '',
  items: [{ label: 'Add a note about this request', value: 'add-note', type: 'checkbox' }],
  required: false,
  separator: true,
};

// Revealed by inputAddNoteToggle. Stored on the request as additionalInformation.
export const inputAdditionalInformation: MpfFormFieldConfig = {
  name: 'additionalInformation',
  type: 'textarea',
  // Visually hidden (see PrescriptionListView) - the checkbox above names the field.
  label: 'Add a note about this request',
  hint: "Your note may not be seen or replied to. If it's urgent, contact your GP surgery.",
  required: false,
  rows: 5,
  maxLength: 450,
  headingLevelSize: 's',
  counter: true,
};

// ENG-21800 `required` is what makes the cancellation deliberate — MpfForm's
// submit has no disabled binding, so the tick is validated on submit.
export const inputConfirmCancellation: MpfFormFieldConfig = {
  modelValue: null,
  name: 'confirmCancellation',
  type: 'checkboxes',
  label: '',
  items: [{ value: 'confirmed', label: 'I want to cancel this appointment' }],
  required: true,
};

export const inputReasonForAppointment: MpfFormFieldConfig = {
  name: 'reasonForAppointment',
  label: 'Why do you need this appointment?',
  hint: 'Briefly describe your symptoms or the reason for the appointment. Do not include anything you would rather discuss in person.',
  type: 'textarea',
  required: true,
  headingLevelSize: 's',
  rows: 5,
};

export const inputPreferredPractitionerGenders: MpfFormFieldConfig = {
  modelValue: null,
  name: 'preferredPractitionerGenders',
  type: 'checkboxes',
  legend: 'Practitioner gender',
  label: 'Practitioner gender',
  hint: 'Leave both unticked if you have no preference.',
  items: [
    { value: 'MALE', label: 'Male' },
    { value: 'FEMALE', label: 'Female' },
  ],
  required: false,
};

export const inputReplyMessage: MpfFormFieldConfig = {
  name: 'replyMessage',
  label: 'Your reply',
  // Visually hidden: the surrounding copy already says what this is, and V1 hid it too.
  srLabel: 'Your reply',
  type: 'textarea',
  required: true,
  rows: 5,
};
